import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import {
  PresenterSettings as PresenterSettingsComponent,
  AgoraAttendeeTile,
  AttendeeTile
} from '@shoflo/polymer';

import { updatePresenterSettings } from 'actions/presenter';
import { useModal } from 'hooks';
import {
  CAMERA_PRESENTER,
  GENERIC_PRESENTER_SETTINGS,
  VENDOR_AGORA
} from '@studio/constants';

function GenericPresenterSettings() {
  const dispatch = useDispatch();
  const meetingSession = useSelector(state => state.meeting.meetingSession);
  const attendeeTiles = useSelector(state => state.meeting.attendeeTiles);
  const presenterSettingsSource = useSelector(
    state => state.presenterSettingsSource
  );

  const { isOpen, clear, initialValue } = useModal(GENERIC_PRESENTER_SETTINGS);

  const vendor = initialValue?.vendor;

  function handleFormSave(payload) {
    dispatch(updatePresenterSettings(presenterSettingsSource, payload));
    clear();
  }

  const maxWidthMap = {
    [CAMERA_PRESENTER]: '436px',
    default: '572px'
  };

  const style = {
    maxWidth: maxWidthMap[presenterSettingsSource.type] || maxWidthMap.default
  };

  const AttendeeTileComponent =
    vendor === VENDOR_AGORA ? AgoraAttendeeTile : AttendeeTile;

  return (
    <Modal isOpen={isOpen} toggle={clear} autoFocus style={style}>
      <PresenterSettingsComponent
        source={presenterSettingsSource}
        meetingSession={meetingSession}
        attendeeTiles={attendeeTiles}
        onSubmit={handleFormSave}
        onCancel={clear}
        AttendeeTileComponent={AttendeeTileComponent}
      />
    </Modal>
  );
}

export default GenericPresenterSettings;
